(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-cto-desktop-menu]').forEach(nav => {
      if (nav.dataset.ctoMenuReady) return;
      nav.dataset.ctoMenuReady = 'true';
      const desktop = matchMedia('(min-width: 1200px)');
      const lifecycle = new AbortController();
      const options = {signal: lifecycle.signal};
      const header = nav.closest('.section-header');
      header?.querySelectorAll('header > .header__search summary').forEach(search => {
        search.addEventListener('click', event => {
          const drawer = header.querySelector('header-drawer');
          if (drawer?.mainDetailsToggle?.open) {
            drawer.closeMenuDrawer(event);
            drawer.mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', 'false');
          }
        }, {...options, capture: true});
      });
      const items = [...nav.querySelectorAll(':scope > .navigation-menu > .cto-menu-item')].map(element => {
        const button = element.querySelector(':scope > .cto-menu-trigger > .cto-submenu-toggle');
        const panel = button && document.getElementById(button.getAttribute('aria-controls'));
        return {element, button, panel, timer: null};
      }).filter(item => item.button && item.panel);
      const cancelClose = item => {
        clearTimeout(item.timer);
        item.timer = null;
      };
      const updateBridge = item => {
        if (!desktop.matches || item.element.dataset.ctoMenuOpen !== 'true') return;
        const trigger = item.button.parentElement;
        const triggerBounds = trigger.getBoundingClientRect();
        const panelBounds = item.panel.getBoundingClientRect();
        const gap = Math.max(0, panelBounds.top - triggerBounds.bottom);
        trigger.style.setProperty('--cto-menu-bridge', `${Math.ceil(gap) + 2}px`);
        trigger.style.setProperty('--cto-menu-bridge-left', `${panelBounds.left - triggerBounds.left}px`);
        trigger.style.setProperty('--cto-menu-bridge-width', `${panelBounds.width}px`);
      };
      const setOpen = (item, open) => {
        cancelClose(item);
        item.element.dataset.ctoMenuOpen = String(open);
        item.button.setAttribute('aria-expanded', String(open));
        item.panel.setAttribute('aria-hidden', String(!open));
        item.panel.inert = !open;
        if (open) updateBridge(item);
      };
      const close = (except = null) => items.forEach(item => {
        if (item !== except) setOpen(item, false);
      });
      const open = item => {
        if (!desktop.matches) return;
        close(item);
        setOpen(item, true);
      };
      const scheduleClose = item => {
        cancelClose(item);
        item.timer = setTimeout(() => {
          if (!item.element.matches(':hover') && !item.element.contains(document.activeElement)) setOpen(item, false);
        }, 180);
      };
      items.forEach(item => {
        setOpen(item, false);
        item.button.addEventListener('click', () => {
          if (item.button.getAttribute('aria-expanded') === 'true') setOpen(item, false);
          else open(item);
        }, options);
        item.element.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') open(item);
        }, options);
        item.element.addEventListener('pointerleave', event => {
          if (event.pointerType === 'mouse') scheduleClose(item);
        }, options);
        item.panel.addEventListener('pointerenter', () => cancelClose(item), options);
        item.panel.addEventListener('pointerleave', event => {
          if (event.pointerType === 'mouse') scheduleClose(item);
        }, options);
        item.element.addEventListener('focusout', event => {
          if (!item.element.contains(event.relatedTarget)) scheduleClose(item);
        }, options);
        item.element.addEventListener('keydown', event => {
          if (event.key === 'Escape' && item.button.getAttribute('aria-expanded') === 'true') {
            event.preventDefault();
            event.stopPropagation();
            setOpen(item, false);
            item.button.focus();
          }
          if (event.key === 'ArrowDown' && !item.panel.contains(event.target)) {
            event.preventDefault();
            open(item);
            item.panel.querySelector('a[href]')?.focus();
          }
        }, options);
      });
      nav.classList.add('cto-menu-enhanced');
      document.addEventListener('pointerdown', event => {
        if (!nav.contains(event.target)) close();
      }, options);
      desktop.addEventListener('change', () => close(), options);
      const updateBridges = () => items.forEach(updateBridge);
      const observer = new ResizeObserver(updateBridges);
      observer.observe(nav.closest('.section-header') || nav);
      window.addEventListener('resize', updateBridges, options);
      document.addEventListener('shopify:section:unload', event => {
        if (!event.target.contains(nav)) return;
        close();
        observer.disconnect();
        lifecycle.abort();
      }, options);
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
